<div class="pv-input" [formGroup]="innerForm">
	@if (label) {
		<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
			{{ label }}
		</ic-label>
	}
	@for (lang of langs; track lang) {
		<button
			[class.active]="lang === currentLang"
			[class.error]="errors.has(lang) && !disabled"
			(click)="setCurrentLang(lang)"
		>
			{{ lang }}
		</button>
	}
	@for (lang of langs; track lang) {
		@if (lang === currentLang) {
			<textarea [formControlName]="lang" (blur)="onTouched(lang)" (input)="onChange()"> </textarea>
		}
	}
	@if (errors.has(currentLang)) {
		<div [class.error]="error"><ng-content select=".errors" /></div>
	}
</div>
